
export const payment = {
    selectMethod: '选择支付方式',
    orderSummary: '订单摘要',
    choosePaymentMethod: '选择您偏好的支付方式',
    creditCard: '信用卡/借记卡',
    creditCardDescription: '通过 Stripe 安全地使用您的信用卡或借记卡支付',
    paypalDescription: '使用您的 PayPal 帐户或 PayPal 余额支付',
    securityNote: '您的支付信息已加密并且安全',
    processing: '正在处理支付...',
    paymentFailed: '支付失败，请重试。',
    paymentCancelled: '支付已取消。',
    invalidPaymentMethod: '选择的支付方式无效。',
    networkError: '网络错误，请检查您的连接并重试。',
    paypalPayment: 'PayPal 支付',
    loadingPayPal: '正在加载 PayPal...',
    paypalSecurityNote: '您的支付由 PayPal 安全处理',
    
    // 支付状态轮询翻译
    poller: {
      success: '支付成功完成',
      processing: '支付已确认，正在处理积分...',
      failed: '支付失败',
      unknown: '未知支付状态',
      error: '检查支付状态时出错',
      network_error: '检查支付状态时网络错误',
      starting: '开始支付验证...',
      timeout: '支付验证超时',
      quickSuccess: '支付成功！正在处理您的积分...',
      // 新增的翻译键
      offline: '网络连接中断',
      auth_error: '身份验证失败',
      not_found: '找不到订单',
      server_error: '服务器错误，正在重试...',
      invalid_data: '无效的响应数据',
      invalid_status: '无效的支付状态',
      invalid_order: '无效的订单ID'
    },
    
    // 支付成功页面翻译
    success: {
      title: '支付成功！',
      message: '感谢您的支付。您的交易已成功完成。',
      description: '您现在可以享受所有高级功能。',
      continue: '继续到仪表板'
    },
    
    // 支付回调页面翻译
    callback: {
      cancelled: '用户取消了支付',
      missingParams: '缺少支付参数',
      success: '支付成功完成',
      failed: '支付处理失败',
      timeout: '支付仍在处理中。请稍后检查您的帐户。',
      verificationFailed: '支付验证失败',
      error: '验证支付失败。请联系客服。',
      transactionId: '交易ID',
      status: '状态',
      quickSuccess: '支付成功！您的积分正在处理中，稍后将可用。',
      
      processing: {
        title: '正在处理支付',
        message: '请稍候，我们正在验证您的支付...',
        webhook: '支付已完成，正在处理您的订单...'
      },
      
      quickSuccessDetails: {
        title: '支付成功！',
        processing: '积分正在添加到您的帐户...',
        continue: '继续到仪表板'
      },
      
      successDetails: {
        title: '支付成功！',
        message: '感谢您的支付。您的交易已成功完成。',
        description: '您现在可以享受所有高级功能。',
        continue: '继续到仪表板'
      },
      
      cancelledDetails: {
        title: '支付已取消',
        message: '您的支付已取消。您的帐户未被收取任何费用。',
        description: '您可以重试或选择不同的支付方式。',
        continue: '返回定价页面'
      },
      
      errorDetails: {
        title: '支付错误',
        message: '检查支付状态时发生过多错误。',
        description: '请重试或联系客服。'
      },
      
      timeoutDetails: {
        title: '支付处理中',
        description: '您的支付可能仍在处理中。请几分钟后检查您的帐户，或如有需要请联系客服。',
        continue: '前往仪表板'
      },
      
      failedDetails: {
        title: '支付失败',
        message: '您的支付无法完成。',
        description: '请检查您的支付详情并重试。',
        continue: '重试支付'
      }
    }
  };
